import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'

const styles = theme => ({
  root: {
    textTransform: 'none',
    padding: '0 15px',
  },
  loader: {
    color: theme.palette.white,
  },
  primary: {
    color: theme.palette.white,
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  primaryDisabled: {
    cursor: 'default',
    color: `${theme.palette.white} !important`,
    backgroundColor: theme.palette.primary.light,
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  },
  secondary: {
    border: `1px solid ${theme.palette.background.dark}`,
  },
  secondaryDisabled: {
    pointerEvents: 'none',
    color: theme.palette.background.dark,
  },
  small: {
    minWidth: 96,
    height: 36,
    fontSize: 15,
  },
  medium: {
    minWidth: 175,
    height: 40,
    fontSize: 15,
  },
  large: {
    minWidth: 175,
    height: 50,
  },
})

const SubmitButton = ({
  classes,
  children,
  className,
  disabled,
  loading,
  showLoader,
  variant,
  ...buttonProps
}) => (
  <Button
    disabled={disabled}
    classes={{
      root: classNames(
        classes.root,
        className,
        classes[variant],
        disabled && classes[`${variant}Disabled`],
        classes[buttonProps.size]
      ),
    }}
    {...buttonProps}>
    {showLoader && disabled && loading && variant === 'primary' ? (
      <CircularProgress className={classes.loader} size={21} />
    ) : (
      children
    )}
  </Button>
)

SubmitButton.defaultProps = {
  loading: true,
  showLoader: true,
}

SubmitButton.propTypes = {
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  showLoader: PropTypes.bool,
  variant: PropTypes.oneOf(['primary', 'secondary']),
}

export default withStyles(styles)(SubmitButton)



// WEBPACK FOOTER //
// ./src/components/atoms/buttons/SubmitButton.js